module.exports = __webpack_public_path__ + "img/58e73c0.png";